module.exports = __webpack_public_path__ + "static/media/sms.670d59ad.png";